/**
 * Componente: ChoiceButtons
 * Botões múltiplos para seleção
 */

import React from 'react';

export interface ChoiceOption {
  value: string;
  label: string;
  description?: string;
}

interface ChoiceButtonsProps {
  options: ChoiceOption[];
  selected?: string | string[];
  onSelect: (value: string) => void;
  multiple?: boolean;
  className?: string;
}

export const ChoiceButtons: React.FC<ChoiceButtonsProps> = ({
  options,
  selected,
  onSelect,
  multiple = false,
  className = '',
}) => {
  const isSelected = (value: string) => {
    if (Array.isArray(selected)) {
      return selected.includes(value);
    }
    return selected === value;
  };

  const handleClick = (value: string) => {
    if (multiple && Array.isArray(selected)) {
      if (isSelected(value)) {
        onSelect(selected.filter((v) => v !== value).join(','));
      } else {
        onSelect([...selected, value].join(','));
      }
    } else {
      onSelect(value);
    }
  };

  return (
    <div className={`choice-buttons-group ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`choice-button ${isSelected(option.value) ? 'selected' : ''}`}
          onClick={() => handleClick(option.value)}
        >
          <span className="choice-label">{option.label}</span>
          {option.description && <span className="choice-description">{option.description}</span>}
        </button>
      ))}
    </div>
  );
};

export default ChoiceButtons;
